const OUTCOME_TYPE = "PSLO";
const CONTEXT_TYPE = "program";
const INGRESS_POINT = "PSLO_FILE_UPLOAD";
const OBJECT_TYPE = "outcome";

const enrichPLOs = (program, termId, autoApprove) => {
  return {
    object_type: OBJECT_TYPE,
    context_id: program.id,
    outcome_type: OUTCOME_TYPE,
    context_type: CONTEXT_TYPE,
    ingress_point: INGRESS_POINT,
    effective_term_id: termId,
    archive_term_id: termId,
    auto_approve: autoApprove,
  };
};

export { enrichPLOs, OUTCOME_TYPE };
